import * as React from 'react'

import { usePdfViewerController } from './use-pdf-viewer-controller'

type PdfViewerController = ReturnType<typeof usePdfViewerController>

const PdfViewerContext = React.createContext<PdfViewerController | null>(null)

interface PdfViewerProviderProps {
  sourceUrl: string
  onLoadingComplete?: () => void
  children: React.ReactNode
}

export function PdfViewerProvider({ children, onLoadingComplete, sourceUrl }: PdfViewerProviderProps) {
  const controller = usePdfViewerController({ sourceUrl, onLoadingComplete })

  return <PdfViewerContext.Provider value={controller}>{children}</PdfViewerContext.Provider>
}

export function usePdfViewerContext() {
  const context = React.useContext(PdfViewerContext)
  if (!context) {
    throw new Error('usePdfViewerContext must be used within PdfViewerProvider')
  }
  return context
}
